import {
  SIZE_HEIGHT_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_LARGE,
  SIZE_WIDTH_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_LARGE,
  SIZE_MAX_HEIGHT_SUBMISSION_LIGHTBOX_WRAPPER_LARGE,
  SIZE_HEIGHT_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_SMALL,
  SIZE_WIDTH_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_SMALL,
  SIZE_MARGIN_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL,
  SIZE_MARGIN_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE,
  SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL,
  SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE,
  SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL,
  SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE,
} from '../../design-tokens/build/dictionary';
import { SUBMISSION_RATIO } from './../core/config';
import { getNumberFromToken } from './../core/utils';
import LightboxSize from './../mixins/lightbox-size';

/**
 * @name SubmissionSize
 *
 */
export default {
  name: 'submission-size',
  mixins: [LightboxSize],
  computed: {
    maxSubmissionHeight() {
      const designAccentHeight = this.smallDisplay
        ? SIZE_HEIGHT_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_SMALL
        : SIZE_HEIGHT_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_LARGE;

      const marginBottom = this.smallDisplay
        ? SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL
        : SIZE_MARGIN_BOTTOM_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE;
      const marginTop = this.smallDisplay
        ? SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL
        : SIZE_MARGIN_TOP_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE;

      return getNumberFromToken(designAccentHeight) + getNumberFromToken(marginTop) + getNumberFromToken(marginBottom);
    },

    maxContentHeight() {
      return this.maxSubmissionHeight;
    },

    maxSubmissionWidth() {
      const designAccentWidth = this.smallDisplay
        ? SIZE_WIDTH_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_SMALL
        : SIZE_WIDTH_SUBMISSION_LIGHTBOX_DESIGN_ACCENT_LARGE;

      const margin = this.smallDisplay
        ? SIZE_MARGIN_SUBMISSION_LIGHTBOX_CONSTRAINT_SMALL
        : SIZE_MARGIN_SUBMISSION_LIGHTBOX_CONSTRAINT_LARGE;

      return getNumberFromToken(designAccentWidth) + getNumberFromToken(margin);
    },

    maxContentWidth() {
      return this.maxSubmissionWidth;
    },

    defaultSubmissionDimensions() {
      const height = getNumberFromToken(SIZE_MAX_HEIGHT_SUBMISSION_LIGHTBOX_WRAPPER_LARGE);
      return {
        height,
        width: SUBMISSION_RATIO * height
      };
    },
  },
};
